import { getCorrectedURLSearchParams } from '@novakid/frontend-core';

export function getFlagIsUnifiedFromParams(search: string) {
  const searchParams = getCorrectedURLSearchParams(search);
  const unifiedParam = searchParams.get('isUnified');

  const isUnifiedClassroom = unifiedParam === 'true';
  const isOldClassroom = unifiedParam === 'false';

  return { isUnifiedClassroom, isOldClassroom };
}
